export enum POOL_MANAGEMENT_TABS {
  TOP_POOLS = 'Top Pools',
  MY_POOLS = 'My Pools',
}
